import React from 'react'
import { Box, Chip, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import profilePlaceholder from '../../../assets/placeholders/profile_placeholder.png'
import { PictureWrapper } from '../../../common/ui/colorBox'
import { formatDateToLocale } from '../../../helpers/date'

export function CustomerThreadMessage({ message, author, sentTime, subHead }) {
  return (
    <Box display='flex' flexDirection='row' alignContent='center' sx={{ m: 2 }}>
      <PictureWrapper
        image={profilePlaceholder}
        style={{ width: 32, height: 32, marginTop: '10px' }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '70%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '30px',
            py: '10px'
          }}
        >
          <Typography variant='h6'>{author}</Typography>
          {subHead ? (
            <Typography variant='subtitle1'>
              &nbsp;
              <Chip label={` ${subHead} `} />
              &nbsp;
            </Typography>
          ) : (
            ''
          )}
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          justifyContent='space-between'
          sx={{
            p: '8px',
            backgroundColor: '#c0c4fa',
            borderRadius: '10px',
            minHeight: '50px'
          }}
        >
          <Box minWidth={'250px'}>
            <Typography>{message}</Typography>
          </Box>
          <Box display='flex' justifyContent='flex-end'>
            <Typography variant='caption'>
              {formatDateToLocale(sentTime)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

CustomerThreadMessage.propTypes = {
  message: PropTypes.string,
  author: PropTypes.string,
  sentTime: PropTypes.string,
  subHead: PropTypes.string
}
